import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const Disclaimer = () => {
    return (
        <div className="bg-background">
            {/* Header */}
            <div className="bg-primary py-16">
                <div className="section-container">
                    <Link to="/" className="inline-flex items-center gap-2 text-primary-foreground/80 hover:text-primary-foreground mb-6 transition-colors">
                        <ArrowLeft className="w-4 h-4" />
                        Back to Home
                    </Link>
                    <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-primary-foreground">Disclaimer</h1>
                    <p className="text-primary-foreground/80 mt-4">Last updated: November 07, 2024</p>
                </div>
            </div>

            {/* Content */}
            <div className="section-container py-16">
                <div className="max-w-4xl mx-auto prose prose-lg">
                    <p className="text-muted-foreground leading-relaxed">
                        The information provided on this website is for general informational purposes only.
                    </p>

                    <h2 className="text-2xl font-bold text-foreground mt-12 mb-4">Interpretation and Definitions</h2>
                    
                    <h3 className="text-xl font-semibold text-foreground mt-8 mb-3">Interpretation</h3>
                    <p className="text-muted-foreground leading-relaxed">
                        Words with capitalized initial letters have meanings defined under the following conditions and apply whether used in singular or plural form.
                    </p>

                    <h3 className="text-xl font-semibold text-foreground mt-8 mb-3">Definitions</h3>
                    <ul className="list-disc list-inside text-muted-foreground space-y-2">
                        <li><strong className="text-foreground">Company:</strong> Dhakad Enterprises, Devalkhedi Jhod Jadgdishpur Islam Nagar Road, Bhopal, Madhya Pradesh 462038</li>
                        <li><strong className="text-foreground">Service:</strong> The Website operated by the Company</li>
                        <li><strong className="text-foreground">You:</strong> The individual or entity accessing the Service</li>
                        <li><strong className="text-foreground">Website:</strong> <a href="https://dhakadenterprises.in/" className="text-primary hover:underline">https://dhakadenterprises.in/</a></li>
                    </ul>

                    <h2 className="text-2xl font-bold text-foreground mt-12 mb-4">General Disclaimer</h2>
                    <p className="text-muted-foreground leading-relaxed">
                        The Company assumes no responsibility for errors or omissions in the contents of the Service.
                    </p>
                    <p className="text-muted-foreground leading-relaxed mt-4">
                        In no event shall the Company be liable for any special, direct, indirect, consequential, or incidental damages arising out of the use of the Service or its contents.
                    </p>

                    <h2 className="text-2xl font-bold text-foreground mt-12 mb-4">External Links Disclaimer</h2>
                    <p className="text-muted-foreground leading-relaxed">
                        The Service may contain links to external websites that are not provided, maintained, or affiliated with the Company.
                    </p>
                    <p className="text-muted-foreground leading-relaxed mt-4">
                        The Company does not guarantee the accuracy, relevance, timeliness, or completeness of information on external websites.
                    </p>

                    <h2 className="text-2xl font-bold text-foreground mt-12 mb-4">Errors and Omissions Disclaimer</h2>
                    <p className="text-muted-foreground leading-relaxed">
                        While the Company takes reasonable steps to ensure accuracy, errors or omissions may occur due to changing laws, rules, or regulations.
                    </p>
                    <p className="text-muted-foreground leading-relaxed mt-4">
                        The Company is not responsible for the results obtained from the use of this information.
                    </p>

                    <h2 className="text-2xl font-bold text-foreground mt-12 mb-4">Fair Use Disclaimer</h2>
                    <p className="text-muted-foreground leading-relaxed">
                        The Company may use copyrighted material under "fair use" as provided under Section 107 of the U.S. Copyright Act.
                    </p>
                    <p className="text-muted-foreground leading-relaxed mt-4">
                        If You wish to use copyrighted material beyond fair use, You must obtain permission from the copyright owner.
                    </p>

                    <h2 className="text-2xl font-bold text-foreground mt-12 mb-4">Views Expressed Disclaimer</h2>
                    <p className="text-muted-foreground leading-relaxed">
                        The views and opinions expressed on the Service are those of the authors and do not necessarily reflect the official policy of the Company.
                    </p>
                    <p className="text-muted-foreground leading-relaxed mt-4">
                        Users are solely responsible for comments posted by them, and the Company reserves the right to remove comments at its discretion.
                    </p>

                    <h2 className="text-2xl font-bold text-foreground mt-12 mb-4">No Responsibility Disclaimer</h2>
                    <p className="text-muted-foreground leading-relaxed">
                        The information provided does not constitute legal, financial, or professional advice and should not be relied upon as such.
                    </p>

                    <h2 className="text-2xl font-bold text-foreground mt-12 mb-4">"Use at Your Own Risk" Disclaimer</h2>
                    <p className="text-muted-foreground leading-relaxed">
                        All information is provided "as is" without warranties of any kind, express or implied.
                    </p>
                    <p className="text-muted-foreground leading-relaxed mt-4">
                        The Company shall not be liable for any decisions or actions taken based on the information provided on the Service.
                    </p>

                    <h2 className="text-2xl font-bold text-foreground mt-12 mb-4">Contact Us</h2>
                    <ul className="list-disc list-inside text-muted-foreground space-y-2">
                        <li><strong className="text-foreground">Email:</strong> <a href="mailto:Prashantdhakad12345@gmail.com" className="text-primary hover:underline">Prashantdhakad12345@gmail.com</a></li>
                        <li><strong className="text-foreground">Website:</strong> <a href="https://dhakadenterprises.in/" className="text-primary hover:underline">dhakadenterprises.in</a></li>
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default Disclaimer;
